
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 50 50"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M2.65 43.01v-.68V7.49c0-2.08 1.46-3.57 3.54-3.57 12.46-.01 24.93-.01 37.39 0 2.09 0 3.56 1.48 3.56 3.56 0 7.52 0 15.03-.01 22.55 0 .39.12.69.35.99 2.48 3.21 3.08 6.77 1.6 10.53-1.48 3.79-4.37 6.08-8.4 6.63-4.39.6-7.87-1.11-10.41-4.74-.09-.12-.16-.25-.27-.42-9.06-.01-18.17-.01-27.35-.01zm28.53-5.37c0 4.36 3.57 7.97 7.82 8.07 4.16.1 8.22-3.2 8.27-8.04.04-4.39-3.61-8.05-7.99-8.06-4.48-.01-8.09 3.56-8.1 8.03zM16.75 22.16v-6.51H5.25v6.51h11.5zm.02 2.62H5.25v6.48h11.52v-6.48zM5.24 40.4h11.51v-6.45H5.24v6.45zM16.77 6.55c-.13-.01-.22-.03-.32-.03H6.16c-.61 0-.93.34-.93.99-.01 1.13 0 2.27 0 3.4v2.12h11.55c-.01-2.18-.01-4.32-.01-6.48zm13.89.01H19.44V13h11.22V6.56zm-.01 15.6v-6.5h-11.2v6.5h11.2zm2.69-6.52v6.5h11.2v-6.5h-11.2zm-13.9 15.63h11.22v-6.49H19.44v6.49zm13.89-18.25h11.25v-.52-4.85c0-.85-.28-1.13-1.14-1.13H33.33v6.5zm-4.08 20.93h-9.8v6.48h9.49c-.56-2.22-.46-4.36.31-6.48zm15.31-9.17H33.34v3.98c3.7-2.22 7.42-2.33 11.22-.33v-3.65z"}}),_c('path',{attrs:{"d":"M37.92 30.52h2.55v7.57l-4.56 4.56c-.55-.55-1.13-1.14-1.73-1.73 1.23-1.2 2.5-2.45 3.74-3.67v-6.73z"}})])
          )
        }
      }
    